/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { INodeProps, Modal, ModalBody, ModalFooter, ModalHeader } from '@msdyn365-commerce-modules/utilities';
import React from 'react';
import { IHerbalVideoPlayerViewProps } from '../herbal-text-block-video';

export interface IHerbalVideoPlayerPopup {
    id: string;
    showVideoPopup: boolean;
    videoPlayer: IHerbalVideoPlayerViewProps | undefined;
    resources: IHerbalVideoPlayerPopupResourceString;
    config: IHerbalVideoPlayerPopupConfig;
    onClick(event: React.MouseEvent<HTMLElement>): void;
    onCloseButtonClick(): void;
}

export interface IHerbalVideoPlayerProps {
    videoPlayerWrapper: INodeProps;
    videoPlayerLink: React.ReactElement;
    videoPlayerDialog: React.ReactNode;
}

export interface IHerbalVideoPlayerPopupResourceString {
    videoPlayerCloseButtonAriaLabel: string;
}

export interface IHerbalVideoPlayerPopupConfig {
    videoPlayerLinkText: string;
}

export const HerbalVideoPlayerPopup = (props: IHerbalVideoPlayerPopup): IHerbalVideoPlayerProps | undefined => {
    const {
        id,
        showVideoPopup,
        videoPlayer,
        config: { videoPlayerLinkText },
        onCloseButtonClick,
        onClick
    } = props;

    if (!videoPlayer) {
        return;
    }

    const titleId = `${id}_title`;
    const className = 'ms-text-block__video-player';
    return {
        videoPlayerWrapper: {
            className: 'ms-text-block__video-player'
        },
        videoPlayerLink: (
            <a className='ms-text-block__video-player_link btn-page' tabIndex={0} role='link' onClick={onClick}>
                {' '}
                {videoPlayerLinkText}{' '}
            </a>
        ),
        videoPlayerDialog: (
            <Modal isOpen={showVideoPopup} className={`${className}`} toggle={onCloseButtonClick}>
                <ModalHeader className={`${className}__dialog__header`} toggle={onCloseButtonClick}>
                    <h5 id={titleId} className='ms-text-block__video-player-popup_title'></h5>
                </ModalHeader>
                <ModalBody className={`${className}__dialog__body`}>
                    <div id={props.id} className='ms-video-player'>
                        {videoPlayer.player}
                    </div>
                </ModalBody>
                <ModalFooter className={`${className}__dialog__footer`} />
            </Modal>
        )
    };
};
